import { createAsyncThunk } from "@reduxjs/toolkit";
import { type EscalateParams } from "../../../domain/entities/reschedule";
import { type ReschedulesDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const escalate = createAsyncThunk<
  void,
  EscalateParams,
  { dispatch: ReschedulesDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.ESCALATE, async (params, { extra }) => {
  await extra.reschedulesRepo.escalate(params);
});
